import { render, staticRenderFns } from "./overallRankingList.vue?vue&type=template&id=2a7500ee&scoped=true"
import script from "./overallRankingList.vue?vue&type=script&lang=js"
export * from "./overallRankingList.vue?vue&type=script&lang=js"
import style0 from "./overallRankingList.vue?vue&type=style&index=0&id=2a7500ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7500ee",
  null
  
)

export default component.exports